import React from "react";
import { SubscriptionStatus } from "../../auth/AuthContext";
import { ITEM_BATCH_ACTION_LABELS, ItemBatchActionType } from "../model/item-batch.types";

const INHOUSE_ACTIONS: ItemBatchActionType[] = [
    'try_assign_my_compare_item',
    'change_rank_price_basis',
    'change_gap_price_basis',
    'change_adjust_strategy',
    'instant_process_dry_run',
];

interface ItemListBatchActionProps {
    selectedItems: Array<{ is_active: boolean; is_urgent_enqueue_pending?: boolean }>;
    onActionChange: (action: ItemBatchActionType) => void;
    subscriptionStatus?: SubscriptionStatus | null;
    allowDryRun: boolean;
    showInhouse: boolean;
}

export const ItemListBatchAction: React.FC<ItemListBatchActionProps> = ({
    selectedItems,
    onActionChange,
    subscriptionStatus,
    allowDryRun,
    showInhouse,
}) => {
    const selectedItemsCount = selectedItems.length;
    const canRequestUrgentEnqueue = selectedItemsCount > 0 && selectedItems.every((item) => item.is_active);
    const canCancelUrgentEnqueue = selectedItemsCount > 0 && selectedItems.every((item) => item.is_urgent_enqueue_pending === true);
    const isPaymentValid = subscriptionStatus?.is_valid ?? true;
    const maxItemCount = subscriptionStatus?.max_item_count ?? 0;
    const registeredItemCount = subscriptionStatus?.registered_item_count ?? 0;
    const activeItemCount = subscriptionStatus?.active_item_count ?? 0;
    const isOverItemLimit = maxItemCount > 0 && registeredItemCount > maxItemCount;
    const renderActionOption = (action: ItemBatchActionType) => (
        <option
            key={action}
            value={action}
            disabled={
                (action === 'request_urgent_enqueue' && !canRequestUrgentEnqueue)
                || (action === 'cancel_urgent_enqueue' && !canCancelUrgentEnqueue)
                || ((action === 'instant_process' || action === 'instant_process_dry_run') && (selectedItemsCount !== 1 || !isPaymentValid))
            }
        >
            {ITEM_BATCH_ACTION_LABELS[action]}
        </option>
    );

    return (
        <div className="row align-items-center">
            <div className="col-auto">
                <select
                    className="form-select"
                    disabled={selectedItemsCount < 1}
                    onChange={(e) => {
                        const action = e.target.value as ItemBatchActionType;
                        if (action) onActionChange(action);
                        e.target.value = '';
                    }}
                    defaultValue=""
                >
                    <option value="">-- 작업 선택 --</option>
                    {(Object.keys(ITEM_BATCH_ACTION_LABELS) as ItemBatchActionType[])
                        .filter((action) => !INHOUSE_ACTIONS.includes(action))
                        .map(renderActionOption)}
                    {(showInhouse || allowDryRun) && (
                        <>
                            <option disabled>----- 인하우스 전용 -----</option>
                            {INHOUSE_ACTIONS.map((action) => (
                                action === 'instant_process_dry_run' ? (allowDryRun ? renderActionOption(action) : null)
                                    : (showInhouse ? renderActionOption(action) : null)
                            ))}
                        </>
                    )}
                </select>
            </div>
            <div className="col-auto">
                {selectedItemsCount > 0 && `${selectedItemsCount}건 선택중`}
            </div>
            <div className="col text-end">
                {maxItemCount > 0 && (
                    <>
                        {`등록 ${registeredItemCount} / ${maxItemCount}건`}
                        {isOverItemLimit && ` · 활성 ${activeItemCount} / ${maxItemCount}건`}
                    </>
                )}
            </div>
        </div>
    );
};

export default ItemListBatchAction;
